import { render, staticRenderFns } from "./footer2.vue?vue&type=template&id=d6254c22&scoped=true"
import script from "./footer2.vue?vue&type=script&lang=js"
export * from "./footer2.vue?vue&type=script&lang=js"
import style0 from "./footer2.vue?vue&type=style&index=0&id=d6254c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6254c22",
  null
  
)

export default component.exports